import fromTheme from './fromTheme';

/**
 * Fetch transitionTime from the current theme.
 */
const transitionTime = () => {
    /**
     * We check if the user has set prefers-reduced-motion, if so transition time is set very low.
     *
     * The negation in the check supports user agents which don't support this property.
     * In such cases this condition will safely fail, and the theme's transition time will be used.
     *
     * @see https://www.joshwcomeau.com/react/prefers-reduced-motion/
     */
    if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        return () => '0.01ms';
    }

    return fromTheme((theme) => theme.transitionTime);
};

export default transitionTime;
